import { FuelType, ParkingTimeSlot } from '../fleet-vehicle';

export interface ICreateEasyInputDto {
	index: number;
	carListBandName: string;
	brand: string;
	model: string;
	quantity: number;
	fuelType: FuelType;
	averageKmDaily: number;
	siteName: string;
	parkingDurationMins: number;
	parkingTimeSlot: ParkingTimeSlot;
}

export class CreateEasyInputDto implements ICreateEasyInputDto {
	index: number;
	carListBandName: string;
	brand: string;
	model: string;
	quantity: number;
	fuelType: FuelType;
	averageKmDaily: number;
	siteName: string;
	parkingDurationMins: number;
	parkingTimeSlot: ParkingTimeSlot;
}
